import React, { Component } from 'react'
import Container from '../../components/layout/container.component'
import Title from '../../components/typography/title.component'
import { StyledRegulation } from './about.styles'

class AboutPage extends Component {
	render() {
		const { history } = this.props

		return (
			<Container style={{ paddingBottom: '5rem' }}>
				<Title>
					<span className="bold">Muviflex - Nossa História</span>
				</Title>
				<StyledRegulation>
					<p>
						O Muviflex é um serviço inovador de vantagens, pioneiro no
						transporte terrestre de passageiros, criado para oferecer uma
						experiência de viagem única e personalizada. Originado em
						Porto Alegre, Rio Grande do Sul, Brasil, no ano de 2018, o
						Muviflex permite aos passageiros acumular pontos a cada
						viagem, que podem ser trocados por bilhetes de passagens.
					</p>
					<p>
						Desde seu lançamento, o Muviflex tem se destacado por sua
						capacidade de adaptação e inovação. A evolução contínua levou
						à criação do Muvicard, um cartão digital creditário que
						facilita pagamentos e a acumulação de pontos de fidelidade. O
						Muvicard promove uma experiência de viagem mais conveniente e
						personalizada, refletindo o compromisso do Muviflex com a
						melhoria contínua dos serviços e com a inclusão digital e
						financeira dos usuários.
					</p>
					<p>
						Com o tempo, o Muviflex se tornou um e-commerce, expandindo
						suas operações para vender bilhetes de passagens de diversas
						transportadoras. Esta expansão permitiu que mais passageiros
						pudessem se beneficiar dos serviços oferecidos pelo Muviflex.
					</p>

					<h3>Muviflex - Uma Empresa de Base Tecnológica e Criativa</h3>
					<p>
						O Muviflex é uma pessoa jurídica de base tecnológica,
						inovadora e parte integrante da economia criativa. Este
						compromisso com a inovação e a criatividade está no cerne de
						todas as atividades, impulsionando o desenvolvimento de
						soluções que melhoram continuamente a experiência de viagem
						dos passageiros.
					</p>

					<h3>Compromisso com a Inclusão Digital e a Proteção de Dados</h3>
					<p>
						O Muviflex é resultado de um compromisso inabalável com a
						inovação e a inclusão digital. Reconhecendo a importância de
						garantir que todos os passageiros tenham acesso às tecnologias
						digitais, o Muviflex se esforça para proporcionar ferramentas
						e recursos que facilitem a vida de seus usuários. O Muvicard,
						por exemplo, não só simplifica os pagamentos, mas também
						garante que os passageiros possam gerenciar suas viagens e
						recompensas de maneira fácil e segura.
					</p>

					<p>
						A proteção de dados e a segurança da informação são pilares
						fundamentais das operações do Muviflex. Investimentos
						contínuos em tecnologia de ponta garantem que as informações
						dos usuários sejam protegidas contra qualquer ameaça. A
						implementação de robustas políticas de segurança da informação
						assegura a integridade e a confidencialidade dos dados,
						reforçando a confiança dos passageiros.
					</p>

					<h3>Foco no Cliente e Atendimento Humanizado</h3>

					<p>
						O foco do Muviflex é o cliente, oferecendo um atendimento
						humanizado e personalizado. Mesmo com a incorporação de novas
						tecnologias baseadas em inteligência artificial, o Muviflex
						mantém o atendimento pessoal como seu diferencial. Cada
						interação é projetada para garantir que os passageiros se
						sintam valorizados e compreendidos, proporcionando uma
						experiência de viagem única e satisfatória.
					</p>

					<h3>Compromisso com Princípios ESG</h3>

					<p>
						A inovação no Muviflex e no Muvicard reflete o compromisso com
						os princípios ESG (ambientais, sociais e de governança). A
						adoção desses princípios está integrada em todas as operações
						e inovações, reafirmando o papel do Muviflex como líder em
						inovação no setor de transportes e consolidando o compromisso
						com a sustentabilidade e a inclusão digital e financeira.
					</p>

					<p>
						O Muviflex também se dedica a práticas sustentáveis,
						minimizando o impacto ambiental de suas operações e promovendo
						a responsabilidade social em todas as suas iniciativas.
					</p>
				</StyledRegulation>
			</Container>
		)
	}
}

export { AboutPage as ModuleRootComponent }
